export const APP_ID_PATTERN = /^[a-z0-9]+(~[a-z0-9]+)*$/;
export const APP_ID_EXTRACTOR = /(?:^|~)([a-z0-9]+)/g;
